export default "__VITE_ASSET__Dv0vamyo__"